import { ref } from 'vue';
import { messengerAPI, type MessengerConnectRequest } from '../services/api';
import { getI18nT } from '../i18n';

const isLoading = ref(false);
const error = ref<string | null>(null);

export function useMessengerFacebook() {
  const connect = async (organizationId: string, sourceId: string): Promise<void> => {
    isLoading.value = true;
    error.value = null;

    try {
      const response = await messengerAPI.getAuthUrl(organizationId, sourceId);
      window.open(
        response.redirect_url,
        'facebook-messenger-auth',
        'width=600,height=700,left=200,top=100',
      );
    } catch (err: any) {
      console.error('Error getting Messenger auth URL:', err);
      const t = getI18nT();
      error.value = err.response?.data?.message || t('composables.messenger.error_connect');
    } finally {
      isLoading.value = false;
    }
  };

  const connectPage = async (data: MessengerConnectRequest): Promise<boolean> => {
    isLoading.value = true;
    error.value = null;

    try {
      await messengerAPI.connectPage(data);
      return true;
    } catch (err: any) {
      console.error('Error connecting Messenger page:', err);
      const t = getI18nT();
      error.value = err.response?.data?.message || t('composables.messenger.error_connect_page');
      return false;
    } finally {
      isLoading.value = false;
    }
  };

  const disconnect = async (organizationId: string): Promise<void> => {
    isLoading.value = true;
    error.value = null;

    try {
      await messengerAPI.disconnect(organizationId);
    } catch (err: unknown) {
      console.error('Error disconnecting Messenger:', err);
      const t = getI18nT();
      const axiosError = err as { response?: { data?: { message?: string } } };
      error.value = axiosError.response?.data?.message || t('composables.messenger.error_disconnect');
    } finally {
      isLoading.value = false;
    }
  };

  return { isLoading, error, connect, connectPage, disconnect };
}
